import { render, staticRenderFns } from "./NoApply.vue?vue&type=template&id=2b979b88&"
import script from "./NoApply.vue?vue&type=script&lang=js&"
export * from "./NoApply.vue?vue&type=script&lang=js&"
import style0 from "./NoApply.vue?vue&type=style&index=0&id=2b979b88&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports